export { default as VictoryArea } from "./victory-area";
export { default as Area } from "./area";


//////////////////
// WEBPACK FOOTER
// ./~/victory-area/es/index.js
// module id = ./node_modules/victory-area/es/index.js
// module chunks = 1